import { Injectable } from '@angular/core';
import { BuildDateFilter } from '@greco/ngx-filters';

@Injectable({ providedIn: 'any' })
export class PurchaseCreatedDateFilter extends BuildDateFilter('PurchaseCreatedDateFilter', {
  label: 'Purchase Date',
  shortLabel: 'Date',
  description: '',
  properties: ['created'],
}) {}
